// extracted by mini-css-extract-plugin
export var linkText = "_mv-0";